import React from 'react'
import imageUnavailable from '../../assets/images/image_unavailable.png'

interface UserJourneyProps {
  organization: string;
  title: string;
  location: string;
  logo_url: string;
  showBorder: boolean;
}

const UserJourney: React.FC<UserJourneyProps> = ({ organization, title, location, logo_url, showBorder }) => {

  return (
    <div className={`${!showBorder ? "border-b" : ''} flex pt-4 pb-2 gap-2`}>
      <div className='rounded-full w-8 h-8 overflow-hidden flex items-center'>
       {
        logo_url? <img src={logo_url} alt="company_logo" className='w-[100%]' />:
        <img src={imageUnavailable} alt="" />
       }
      </div>

      <div className='ml-1'>
        <h6 className='text-tertiary-light text-[13px]'>{organization}</h6>
        <h5 className='text-[14px] text-[#232323] font-normal'>{title}</h5>
        <h6 className='text-[#707070] text-[12px] mt-0.5'>{location}</h6>
      </div>
    </div>

  )
}

export default UserJourney